import { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import moment from 'moment';

import {
  TEntityGridConstraints,
  TEntityGridExtraFilter,
} from 'app/common/entity-grid/core';
import * as EntityGrid from 'app/common/entity-grid/features';
import { StringFilterDataGrid } from 'app/common/ui/data-grid/filters';
import { RangeDateFilterModel } from 'app/common/ui/data-grid/filters/range-date/core';
import { HttpRequest } from 'app/libs/http-client';
import { useUserRoles } from 'app/railways/domains/access/features/roles/use-user-roles';

import { TTicketOrdersConstraints } from '../../core/tickets-orders-constraints';
import { getTicketOrdersRequest } from '../../requests';
import { cols } from './ticket-orders-columns';

export const TicketOrdersEntityGrid = observer(() => {
  const userRoles = useUserRoles();

  const DATE_COLUMN_NAME = 'date';
  const mapRequestParams = (
    constraints?: TTicketOrdersConstraints,
  ): HttpRequest => {
    const filters = { ...constraints?.filter };

    // map data grid RangeDateFilter Value to Server API Filter
    if (DATE_COLUMN_NAME in filters) {
      const rangeFilter = filters[
        DATE_COLUMN_NAME
      ] as RangeDateFilterModel['value'];

      filters['lowDate'] = rangeFilter.start.toJSON();
      filters['highDate'] = rangeFilter.end.toJSON();

      delete filters[DATE_COLUMN_NAME];
    }

    const updatedConstraints: TTicketOrdersConstraints = {
      ...constraints,
      sorting: constraints?.sorting || [],
      filter: filters,
    };

    return getTicketOrdersRequest(updatedConstraints);
  };

  const initialConstraints = useMemo<TEntityGridConstraints>(
    () => ({
      sorting: [{ name: 'id', direction: 'descend' }],
      filter: {
        [DATE_COLUMN_NAME]: {
          // 7 day * 24h * 60min * 60sec * 1000ms
          start: moment().subtract(1, 'week').startOf('day').toDate(),
          end: moment().endOf('day').toDate(),
        },
      },
    }),
    [],
  );

  const extraFilters = useMemo<TEntityGridExtraFilter[]>(
    () => [
      {
        header: 'Номер телефона покупателя',
        component: StringFilterDataGrid({ filterName: 'personPhone' }),
      },
    ],
    [],
  );

  return (
    <EntityGrid.Root
      columns={cols}
      rowModelType="largeList"
      recordsLimit={1000}
      initialState={initialConstraints}
      request={mapRequestParams}
      userRoles={userRoles}
      extraFilters={extraFilters}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
          padding: 16,
          height: '100%',
        }}
      >
        <EntityGrid.NotificationsRender>
          {(notifications) => <div>{notifications}</div>}
        </EntityGrid.NotificationsRender>

        <div style={{ flexGrow: 1 }}>
          <EntityGrid.Table
            rowSelection="multiple"
            persistSettingsId="TripsOrdersEntityGrid"
          />
        </div>
      </div>
    </EntityGrid.Root>
  );
});
